// Signals contain no roster data. Receivers must fetch their own authorised view.
const CHANNEL = 'vigilant.role-roster-refresh';
const source = Math.random().toString(36).slice(2);

export function publishRosterChange(workspaceId: string) {
  try {
    const channel = new BroadcastChannel(CHANNEL);
    channel.postMessage({ workspaceId, source });
    channel.close();
  } catch {
    /* Optional browser support; focus refresh remains available. */
  }
}

export function subscribeRosterChanges(
  getWorkspaceId: () => string | undefined,
  refresh: (workspaceId: string) => void
): () => void {
  try {
    const channel = new BroadcastChannel(CHANNEL);
    channel.onmessage = ({ data }: MessageEvent<unknown>) => {
      if (!data || typeof data !== 'object') return;
      const event = data as { workspaceId?: unknown; source?: unknown };
      if (event.source === source || typeof event.workspaceId !== 'string') return;
      if (event.workspaceId === getWorkspaceId()) refresh(event.workspaceId);
    };
    return () => channel.close();
  } catch {
    return () => {};
  }
}
